import React, { useState } from "react";

// Import all company images
import img1 from "../Photos/1. TFU Logo (5) - Kamalpreet Kaur.png";
import img2 from "../Photos/2. RT Fitness.png";
import img3 from "../Photos/3. Virtuosoft.jpeg";
import img4 from "../Photos/4. mentorle logo - Rachit Jain.jpeg";
import img5 from "../Photos/5. Brandclever_s Logo - HR Brandclever.png";
import img6 from "../Photos/6.Websetters.png";
import img7 from "../Photos/7. CipherSchools.png";
import img8 from "../Photos/8. IWTPL-logo (1) - Seema Sharma.png";
import img9 from "../Photos/9. Code Driven.jpeg";
import img10 from "../Photos/10. Kbizsoft.png";
import img11 from "../Photos/11. Swasth AI.png";
import img12 from "../Photos/12. SEO Discovery.png";
import img13 from "../Photos/13. Seoily.png";
import img14 from "../Photos/14. logo - Busy Bucket.png";
import img15 from "../Photos/16. Builtin studios - Archit Mehta.webp";
import img16 from "../Photos/17. Finch.webp";
import img17 from "../Photos/19. insidefpv_logo - Prateek Gupta.png";
import img18 from "../Photos/20. VNG.webp";
import img19 from "../Photos/Online Codefeast.png";
import img20 from "../Photos/Online Flive.jpg";
import img21 from "../Photos/Online PPM.png";
import img22 from "../Photos/Online Vision Wise.jpg";
import img23 from "../Photos/Online wooplix Final Favicon Sticker - mahi sharma.png";

const CompanyLogosGrid = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);

  // Company data with images and descriptions
  const companies = [
    {
      id: 1,
      name: "TFU",
      logoUrl: img1,
      //   description:
      // "A leading educational institution focused on future-ready skills and professional development.",
    },
    {
      id: 2,
      name: "RT Fitness",
      logoUrl: img2,
      //   description:
      // "Premium fitness solutions provider offering personalized training and wellness programs.",
    },
    {
      id: 3,
      name: "Virtuosoft",
      logoUrl: img3,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    // Add descriptions for all companies...
    {
      id: 4,
      name: "Mentorle",
      logoUrl: img4,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 5,
      name: "Brandclever",
      logoUrl: img5,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 6,
      name: "Websetters",
      logoUrl: img6,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 7,
      name: "CipherSchools",
      logoUrl: img7,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 8,
      name: "IWTPL",
      logoUrl: img8,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 9,
      name: "Code Driven",
      logoUrl: img9,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 10,
      name: "Kbizsoft",
      logoUrl: img10,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 11,
      name: "Swasth AI",
      logoUrl: img11,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 12,
      name: "SEO Discovery",
      logoUrl: img12,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 13,
      name: "Seoily",
      logoUrl: img13,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 14,
      name: "Busy Bucket",
      logoUrl: img14,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 15,
      name: "Builtin Studios",
      logoUrl: img15,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 16,
      name: "Finch",
      logoUrl: img16,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 17,
      name: "Inside FPV",
      logoUrl: img17,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 18,
      name: "VNG",
      logoUrl: img18,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 19,
      name: "Codefeast",
      logoUrl: img19,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 20,
      name: "Flive",
      logoUrl: img20,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 21,
      name: "PPM",
      logoUrl: img21,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 22,
      name: "Vision Wise",
      logoUrl: img22,
      //   description:
      // "Innovative software development company specializing in custom solutions and digital transformation.",
    },
    {
      id: 23,
      name: "Wooplix",
      logoUrl: img23,
      //   description:
      // "Digital solutions provider focusing on modern web technologies and user experience.",
    },
  ];

  const closeModal = () => {
    setSelectedCompany(null);
  };

  return (
    <div className="w-full max-w-6xl p-6 rounded-lg shadow-none">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold">Our Partners</h2>
        <div
          className="relative"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <div className="inline-flex items-center justify-center px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium cursor-pointer">
            {companies.length} Companies
          </div>
          {showTooltip && (
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap">
              Total participating companies
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-8 gap-4">
        {companies.map((company) => (
          <div key={company.id} className="relative group">
            <div
              className="p-4 border rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 flex items-center justify-center h-24 cursor-pointer"
              onClick={() => setSelectedCompany(company)}
            >
              <img
                src={company.logoUrl}
                alt={`${company.name} logo`}
                className="max-w-full max-h-full object-contain"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 rounded-lg">
                <span className="text-sm font-medium">{company.name}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedCompany && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold">{selectedCompany.name}</h3>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="flex items-center justify-center mb-4">
              <img
                src={selectedCompany.logoUrl}
                alt={`${selectedCompany.name} logo`}
                className="max-h-32 object-contain"
              />
            </div>
            <p className="text-gray-600">{selectedCompany.description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyLogosGrid;
